import script from "./InputPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./InputPrimary.vue?vue&type=script&setup=true&lang=js"

import "./InputPrimary.vue?vue&type=style&index=0&id=1e354b18&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e354b18"]])

export default __exports__